// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect__tag{background-color:#2e3a6e}.multiselect__option{font-size:12px}.multiselect__option--highlight,.multiselect__option--highlight:after{background-color:#2e3a6e}.multiselect__tag-icon:after{color:#fff}.custom_support-color{background-color:#2e3a6e}", ""]);
// Exports
module.exports = exports;
